import isNull from 'lodash/isNull';
import omit from 'lodash/omit';

import api from '../REST/api';
import { replaceNestedWithIds } from '../utils/replace-nested-with-id';

function replace(modelWithTransformedIds, key, value) {
  return { ...modelWithTransformedIds, [key]: value };
}

export function transformForRendering(brand) {
  const modelWithTransformedIds = replaceNestedWithIds(brand, 'accounts');
  if (isNull(modelWithTransformedIds.code)) {
    return replace(modelWithTransformedIds, 'code', '');
  }
  return modelWithTransformedIds;
}

export function getTransformedBrand(arg) {
  return api
    .getBrand(arg)
    .then(response => transformForRendering(response || {}));
}

function getFieldsToRemove() {
  return [
    'id',
    'accountIds',
    'created',
    'lastModified',
    'createdBy',
    'lastModifiedBy',
  ];
}

export function transformForPatch(model) {
  const skimmedModel = omit(model, getFieldsToRemove());
  if (skimmedModel.code.trim() === '') {
    return replace(skimmedModel, 'code', null);
  }
  return skimmedModel;
}
